import React from 'react'

export const renderThumb = () => {
  return <div className='react-scrollbar_thumb react-scrollbar_thumb' />
}

export const renderTrackVertical = () => {
  return <div className='react-scrollbar_track react-scrollbar_track--vertical' />
}

export const renderTrackHorizontal = () => {
  return <div className='react-scrollbar_track react-scrollbar_track--horizontal' />
}
